// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Slide container ─────────────────────────────────────── */
.ls-slide {
  position: absolute;
  inset: 0;
  background: #1257f5;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: inherit;
}

/* ── Scattered food items ────────────────────────────────── */
.ls-item {
  position: absolute;
  font-size: 3.5rem;
  line-height: 1;
  will-change: transform;
  filter: drop-shadow(0 6px 16px rgba(0,0,0,0.25));
  user-select: none;
  pointer-events: none;
  z-index: 1;
}

/* ── Centre text block ───────────────────────────────────── */
.ls-text {
  position: relative;
  z-index: 10;
  text-align: left;
  padding: 0 2rem;
  animation: lsTextIn 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ls-headline {
  font-size: clamp(2.8rem, 5.5vw, 4.5rem);
  font-weight: 800;
  color: #fff;
  line-height: 1.05;
  letter-spacing: -0.03em;
  margin: 0 0 0.6rem;
}

.ls-sub {
  font-size: clamp(0.9rem, 1.5vw, 1.1rem);
  font-weight: 500;
  color: rgba(255,255,255,0.82);
  line-height: 1.5;
  max-width: 22rem;
  margin: 0;
}

.ls-tag {
  margin: 0.75rem 0 0 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 9999px;
  padding: 4px 14px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: rgba(255,255,255,0.95);
  backdrop-filter: blur(4px);
}

/* ── Footer ─────────────────────────────────────────────── */
.ls-footer {
  position: absolute;
  bottom: 1.25rem;
  left: 1.5rem;
  font-size: 0.7rem;
  color: rgba(255,255,255,0.5);
  letter-spacing: 0.02em;
  display: flex;
  align-items: center;
  gap: 6px;
  pointer-events: none;
}
.ls-footer-icon {
  font-size: 0.85rem;
  opacity: 0.6;
}

/* ════════════════════════════════════════════════════════════
   MICRO-ANIMATION KEYFRAMES
   ════════════════════════════════════════════════════════════ */

/* Generic float variations */
@keyframes floatA {
  0%,100% { transform: translateY(0px)   rotate(0deg)   scale(1); }
  30%     { transform: translateY(-14px) rotate(6deg)   scale(1.04); }
  65%     { transform: translateY(-7px)  rotate(-3deg)  scale(1.01); }
}
@keyframes floatB {
  0%,100% { transform: translateY(0px)  rotate(0deg)   scale(1); }
  40%     { transform: translateY(12px) rotate(-7deg)  scale(0.97); }
  70%     { transform: translateY(5px)  rotate(4deg)   scale(1.02); }
}
@keyframes floatC {
  0%,100% { transform: translateY(0px)   rotate(0deg)   scale(1); }
  25%     { transform: translateY(-10px) rotate(-5deg)  scale(1.03); }
  60%     { transform: translateY(-18px) rotate(8deg)   scale(1.05); }
  80%     { transform: translateY(-6px)  rotate(-2deg)  scale(1.01); }
}
@keyframes floatD {
  0%,100% { transform: translateY(0px)  rotate(0deg)   scale(1); }
  35%     { transform: translateY(16px) rotate(5deg)   scale(0.96); }
  70%     { transform: translateY(8px)  rotate(-6deg)  scale(1.03); }
}
@keyframes floatE {
  0%,100% { transform: translateY(0px)   rotate(0deg)   scale(1); }
  45%     { transform: translateY(-20px) rotate(-4deg)  scale(1.06); }
  75%     { transform: translateY(-10px) rotate(3deg)   scale(1.02); }
}
@keyframes floatF {
  0%,100% { transform: translateY(0px)  rotate(0deg)   scale(1); }
  20%     { transform: translateY(10px) rotate(9deg)   scale(0.98); }
  55%     { transform: translateY(18px) rotate(-5deg)  scale(0.95); }
  80%     { transform: translateY(6px)  rotate(2deg)   scale(1.01); }
}

/* Text entrance */
@keyframes lsTextIn {
  from { opacity: 0; transform: translateY(18px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* Item entrance (staggered) */
@keyframes lsItemIn {
  from { opacity: 0; transform: scale(0.5) rotate(-15deg); }
  to   { opacity: 1; }
}

/* ── Helper: apply float anims + entrance ────────────────── */
.ls-item { animation: lsItemIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both; }

.ls-item.fa { animation: lsItemIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both,
                          floatA 4.2s ease-in-out 0.5s infinite; }
.ls-item.fb { animation: lsItemIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s both,
                          floatB 3.8s ease-in-out 0.6s infinite; }
.ls-item.fc { animation: lsItemIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s both,
                          floatC 5.1s ease-in-out 0.3s infinite; }
.ls-item.fd { animation: lsItemIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.15s both,
                          floatD 4.6s ease-in-out 0.8s infinite; }
.ls-item.fe { animation: lsItemIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.25s both,
                          floatE 3.5s ease-in-out 0.2s infinite; }
.ls-item.ff { animation: lsItemIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.3s both,
                          floatF 4.9s ease-in-out 1.0s infinite; }

/* ── Sizes ───────────────────────────────────────────────── */
.ls-item.sm  { font-size: 2.2rem; }
.ls-item.md  { font-size: 3.2rem; }
.ls-item.lg  { font-size: 4.5rem; }
.ls-item.xl  { font-size: 5.5rem; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/LoginSlides.css"],"names":[],"mappings":"AAAA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,gDAAgD;EAChD,iBAAiB;EACjB,oBAAoB;EACpB,UAAU;AACZ;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,4DAA4D;AAC9D;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,uCAAuC;EACvC,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;iEAEiE;;AAEjE,6BAA6B;AAC7B;EACE,UAAU,oDAAoD,EAAE;EAChE,UAAU,uDAAuD,EAAE;EACnE,UAAU,uDAAuD,EAAE;AACrE;AACA;EACE,UAAU,mDAAmD,EAAE;EAC/D,UAAU,sDAAsD,EAAE;EAClE,UAAU,sDAAsD,EAAE;AACpE;AACA;EACE,UAAU,oDAAoD,EAAE;EAChE,UAAU,uDAAuD,EAAE;EACnE,UAAU,uDAAuD,EAAE;EACnE,UAAU,uDAAuD,EAAE;AACrE;AACA;EACE,UAAU,mDAAmD,EAAE;EAC/D,UAAU,sDAAsD,EAAE;EAClE,UAAU,sDAAsD,EAAE;AACpE;AACA;EACE,UAAU,oDAAoD,EAAE;EAChE,UAAU,uDAAuD,EAAE;EACnE,UAAU,uDAAuD,EAAE;AACrE;AACA;EACE,UAAU,mDAAmD,EAAE;EAC/D,UAAU,sDAAsD,EAAE;EAClE,UAAU,sDAAsD,EAAE;EAClE,UAAU,sDAAsD,EAAE;AACpE;;AAEA,kBAAkB;AAClB;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,8BAA8B;AAC9B;EACE,OAAO,UAAU,EAAE,oCAAoC,EAAE;EACzD,OAAO,UAAU,EAAE;AACrB;;AAEA,+DAA+D;AAC/D,WAAW,+DAA+D,EAAE;;AAE5E,cAAc;+DACiD,EAAE;AACjE,cAAc;+DACiD,EAAE;AACjE,cAAc;+DACiD,EAAE;AACjE,cAAc;+DACiD,EAAE;AACjE,cAAc;+DACiD,EAAE;AACjE,cAAc;+DACiD,EAAE;;AAEjE,+DAA+D;AAC/D,eAAe,iBAAiB,EAAE;AAClC,eAAe,iBAAiB,EAAE;AAClC,eAAe,iBAAiB,EAAE;AAClC,eAAe,iBAAiB,EAAE","sourcesContent":["/* ── Slide container ─────────────────────────────────────── */\n.ls-slide {\n  position: absolute;\n  inset: 0;\n  background: #1257f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: inherit;\n}\n\n/* ── Scattered food items ────────────────────────────────── */\n.ls-item {\n  position: absolute;\n  font-size: 3.5rem;\n  line-height: 1;\n  will-change: transform;\n  filter: drop-shadow(0 6px 16px rgba(0,0,0,0.25));\n  user-select: none;\n  pointer-events: none;\n  z-index: 1;\n}\n\n/* ── Centre text block ───────────────────────────────────── */\n.ls-text {\n  position: relative;\n  z-index: 10;\n  text-align: left;\n  padding: 0 2rem;\n  animation: lsTextIn 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.ls-headline {\n  font-size: clamp(2.8rem, 5.5vw, 4.5rem);\n  font-weight: 800;\n  color: #fff;\n  line-height: 1.05;\n  letter-spacing: -0.03em;\n  margin: 0 0 0.6rem;\n}\n\n.ls-sub {\n  font-size: clamp(0.9rem, 1.5vw, 1.1rem);\n  font-weight: 500;\n  color: rgba(255,255,255,0.82);\n  line-height: 1.5;\n  max-width: 22rem;\n  margin: 0;\n}\n\n.ls-tag {\n  margin: 0.75rem 0 0 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(255,255,255,0.15);\n  border: 1px solid rgba(255,255,255,0.3);\n  border-radius: 9999px;\n  padding: 4px 14px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: rgba(255,255,255,0.95);\n  backdrop-filter: blur(4px);\n}\n\n/* ── Footer ─────────────────────────────────────────────── */\n.ls-footer {\n  position: absolute;\n  bottom: 1.25rem;\n  left: 1.5rem;\n  font-size: 0.7rem;\n  color: rgba(255,255,255,0.5);\n  letter-spacing: 0.02em;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  pointer-events: none;\n}\n.ls-footer-icon {\n  font-size: 0.85rem;\n  opacity: 0.6;\n}\n\n/* ════════════════════════════════════════════════════════════\n   MICRO-ANIMATION KEYFRAMES\n   ════════════════════════════════════════════════════════════ */\n\n/* Generic float variations */\n@keyframes floatA {\n  0%,100% { transform: translateY(0px)   rotate(0deg)   scale(1); }\n  30%     { transform: translateY(-14px) rotate(6deg)   scale(1.04); }\n  65%     { transform: translateY(-7px)  rotate(-3deg)  scale(1.01); }\n}\n@keyframes floatB {\n  0%,100% { transform: translateY(0px)  rotate(0deg)   scale(1); }\n  40%     { transform: translateY(12px) rotate(-7deg)  scale(0.97); }\n  70%     { transform: translateY(5px)  rotate(4deg)   scale(1.02); }\n}\n@keyframes floatC {\n  0%,100% { transform: translateY(0px)   rotate(0deg)   scale(1); }\n  25%     { transform: translateY(-10px) rotate(-5deg)  scale(1.03); }\n  60%     { transform: translateY(-18px) rotate(8deg)   scale(1.05); }\n  80%     { transform: translateY(-6px)  rotate(-2deg)  scale(1.01); }\n}\n@keyframes floatD {\n  0%,100% { transform: translateY(0px)  rotate(0deg)   scale(1); }\n  35%     { transform: translateY(16px) rotate(5deg)   scale(0.96); }\n  70%     { transform: translateY(8px)  rotate(-6deg)  scale(1.03); }\n}\n@keyframes floatE {\n  0%,100% { transform: translateY(0px)   rotate(0deg)   scale(1); }\n  45%     { transform: translateY(-20px) rotate(-4deg)  scale(1.06); }\n  75%     { transform: translateY(-10px) rotate(3deg)   scale(1.02); }\n}\n@keyframes floatF {\n  0%,100% { transform: translateY(0px)  rotate(0deg)   scale(1); }\n  20%     { transform: translateY(10px) rotate(9deg)   scale(0.98); }\n  55%     { transform: translateY(18px) rotate(-5deg)  scale(0.95); }\n  80%     { transform: translateY(6px)  rotate(2deg)   scale(1.01); }\n}\n\n/* Text entrance */\n@keyframes lsTextIn {\n  from { opacity: 0; transform: translateY(18px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* Item entrance (staggered) */\n@keyframes lsItemIn {\n  from { opacity: 0; transform: scale(0.5) rotate(-15deg); }\n  to   { opacity: 1; }\n}\n\n/* ── Helper: apply float anims + entrance ────────────────── */\n.ls-item { animation: lsItemIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both; }\n\n.ls-item.fa { animation: lsItemIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both,\n                          floatA 4.2s ease-in-out 0.5s infinite; }\n.ls-item.fb { animation: lsItemIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s both,\n                          floatB 3.8s ease-in-out 0.6s infinite; }\n.ls-item.fc { animation: lsItemIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s both,\n                          floatC 5.1s ease-in-out 0.3s infinite; }\n.ls-item.fd { animation: lsItemIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.15s both,\n                          floatD 4.6s ease-in-out 0.8s infinite; }\n.ls-item.fe { animation: lsItemIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.25s both,\n                          floatE 3.5s ease-in-out 0.2s infinite; }\n.ls-item.ff { animation: lsItemIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.3s both,\n                          floatF 4.9s ease-in-out 1.0s infinite; }\n\n/* ── Sizes ───────────────────────────────────────────────── */\n.ls-item.sm  { font-size: 2.2rem; }\n.ls-item.md  { font-size: 3.2rem; }\n.ls-item.lg  { font-size: 4.5rem; }\n.ls-item.xl  { font-size: 5.5rem; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
